import { useState, useEffect, useCallback } from 'react';
import { getFilters } from '../services/ApplicationService';

export interface Officer {
  id: string;
  code: string;
  label: string;
}

export const useOfficers = () => {
  const [officers, setOfficers] = useState<Officer[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchOfficers = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getFilters('application');
      if (response.success && response.data) {
        const officersData = response.data.commercials
          .filter((commercial: any) => commercial.id !== 'null')
          .map((commercial: any) => ({
            id: commercial.id,
            code: commercial.id.padStart(3, '0'),
            label: commercial.name,
          }));
        setOfficers(officersData);
      } else {
        const errorMsg = response.message || 'Error al cargar los oficiales';
        setError(errorMsg);
        console.error('[useOfficers] Error loading:', errorMsg);
      }
    } catch (err) {
      const errorMsg = 'Error al cargar los oficiales';
      setError(errorMsg);
      console.error('[useOfficers] Exception:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOfficers();
  }, [fetchOfficers]);

  const refreshOfficers = useCallback(() => {
    return fetchOfficers();
  }, [fetchOfficers]);

  return {
    officers,
    isLoading,
    error,
    refreshOfficers,
  };
};
